import { useMemo } from 'react'

import {
  AI_CHAT_DISCOVERY_FAB_APPEARANCE,
  AI_CHAT_DISCOVERY_VARIANT,
} from '../constants'
import {
  getAiChatDiscoveryEffectiveVariant,
  isAiChatDiscoveryVariantResolved,
} from '../utils'
import { useAiChatDiscoveryVariant } from './use_ai_chat_discovery_variant'

const { BUTTON_ONLY, CONTROL, TOP_BUTTON } = AI_CHAT_DISCOVERY_VARIANT
const { STRING } = AI_CHAT_DISCOVERY_FAB_APPEARANCE

/**
 * AI discovery experiment: nav link, floating FAB, and FAB shape (`icon` | `string`).
 * Only use from components that mount when {@link useAiChatDiscoveryMiEligible} is true.
 * Experiment exposure is logged by {@link useAiChatDiscoveryExperimentExposure} when an entry point is visible.
 */
export const useAiChatDiscoveryExperiment = () => {
  const variant = useAiChatDiscoveryVariant(false)

  return useMemo(() => {
    const isVariantResolved = isAiChatDiscoveryVariantResolved(variant)
    const effectiveVariant = isVariantResolved
      ? getAiChatDiscoveryEffectiveVariant(variant)
      : null

    const eligibleForFloating = effectiveVariant === BUTTON_ONLY

    let fabAppearance = null
    if (eligibleForFloating) {
      fabAppearance = STRING
    }

    const showsLeftNavAiLink = effectiveVariant === CONTROL

    return {
      effectiveVariant,
      isVariantResolved,
      showsFloatingLauncher: Boolean(eligibleForFloating && fabAppearance),
      showsLeftNavAiLink,
      fabAppearance,
      isTopButtonVariant: effectiveVariant === TOP_BUTTON,
    }
  }, [variant])
}
